import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { InstagramOutlined, FacebookFilled, MenuOutlined, CloseOutlined,LinkedinOutlined} from '@ant-design/icons';
import './Navbar.css';
import logoWhite from '../assets/image/about/cklogo.png';
import logoBlack from '../assets/image/about/cklogo.png';


const Navbar = () => {


  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';

  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navClass = `navbar-container ${!isHome || scrolled ? 'navbar--light' : ''}`;

  const handleNavigate = (path) => {
    navigate(path);
    setMobileOpen(false);
  };

  return (
    <header className={navClass}>
      <div className="navbar-inner">
        <div className="navbar-logo" onClick={() => handleNavigate('/')}>
  <img
  src={isHome && !scrolled ? logoWhite : logoBlack}
  alt="Klyssa Logo"
  className="navbar-logo-img"
/>
</div>

        <nav className={`navbar-links ${mobileOpen ? 'open' : ''} ${isHome && !scrolled ? 'home-style' : 'light-style'}`}>
          <a className="nav-link" onClick={() => handleNavigate('/')}>Home</a>
               
          <a className="nav-link" onClick={() => handleNavigate('/Projects')}>Projects</a>
          
        </nav>

        <div className="navbar-socials">
          <a href="https://instagram.com/hengchengkiat" target="_blank" rel="noreferrer"><InstagramOutlined /></a>
          <a href="https://www.linkedin.com/in/heng-cheng-kiat-63bb7b162/" target="_blank" rel="noreferrer"><LinkedinOutlined /></a>
          <div className="mobile-toggle" onClick={() => setMobileOpen(!mobileOpen)}>
            {mobileOpen ? <CloseOutlined style={{ fontSize: '24px', color: isHome ? 'white' : 'black' }}/> : <MenuOutlined style={{ fontSize: '24px', color: isHome ? 'white' : 'black' }} />}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
